var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#676767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0178 21.8726C19.0178 22.4355 18.5625 22.8917 18.0008 22.8917C17.4392 22.8917 16.9839 22.4355 16.9839 21.8726C16.9839 21.3098 17.4392 20.8535 18.0008 20.8535C18.5625 20.8535 19.0178 21.3098 19.0178 21.8726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2712 23.0955C25.2712 22.874 25.2107 22.6693 25.1058 22.4941V22.4941L19.0041 12.303H19.004C18.7983 11.9593 18.4251 11.7325 18 11.7325C17.5749 11.7325 17.2017 11.9593 16.996 12.303H16.9959L10.8942 22.4941V22.4941C10.7893 22.6693 10.7288 22.874 10.7288 23.0955C10.7288 23.7428 11.2524 24.2675 11.8983 24.2675H24.1017C24.7476 24.2675 25.2712 23.7428 25.2712 23.0955ZM27 23.0955C27 24.6996 25.7024 26 24.1017 26H11.8983C10.2976 26 9 24.6996 9 23.0955C9 22.5513 9.15018 22.0396 9.41179 21.6027L15.5135 11.4116C16.0187 10.5678 16.9427 10 18 10C19.0572 10 19.9813 10.5679 20.4865 11.4116H20.4865L26.5882 21.6027L26.6124 21.6439C26.8591 22.0716 27 22.5683 27 23.0955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1353 19.3245V15.9615C17.1353 15.483 17.5223 15.0952 17.9997 15.0952C18.4771 15.0952 18.8641 15.483 18.8641 15.9615V19.3245C18.8641 19.8029 18.4771 20.1908 17.9997 20.1908C17.5223 20.1908 17.1353 19.8029 17.1353 19.3245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlert);
export default __webpack_public_path__ + "static/media/system_alert.bf57db807edf764d3bac123dbf3a445e.svg";
export { ForwardRef as ReactComponent };